import { jsx as _jsx } from "react/jsx-runtime";
import React, {} from 'react';
import { InputNumber } from "antd";
/**
 * This input allows a user to enter a whole number percentage (e.g. 7%)
 * which converts to its decimal equivalent (e.g. 0.7).
 */
const PercentInput = ({ value, onChange, style = {}, disabled = false, onBlur, precision = 0, min = 0, max = 100 }) => {
    function convertValue(value) {
        if (value === 0) {
            return 0;
        }
        if (!value || isNaN(value)) {
            return null;
        }
        return Math.round(value * Math.pow(10, precision + 4)) / Math.pow(10, precision + 2); // Try to fix Javascript precision issue
    }
    function onInputChanged(value) {
        if (!onChange) {
            return;
        }
        if (value === 0) {
            onChange(value);
        }
        else if (value) {
            onChange(value / 100);
        }
        else {
            onChange(null);
        }
    }
    return (_jsx(InputNumber, { value: convertValue(value), onChange: onInputChanged, min: min, max: max, suffix: "%", style: style, onBlur: onBlur, disabled: disabled, precision: precision }));
};
export default PercentInput;
